import { render, staticRenderFns } from "./UnclaimedChangeReview.vue?vue&type=template&id=85f47aae"
import script from "./UnclaimedChangeReview.vue?vue&type=script&lang=js"
export * from "./UnclaimedChangeReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports